/**
 * Get last slug without params
 *
 * @param url URL to get last slug without params
 *
 * @returns  URL last slug without params
 */
export function getLastSlugWithoutParams(url: string): string | undefined {
    const path = url.split('?')[0];

    return path.split('/').filter(Boolean).pop();
}
